import { inject, Injectable } from '@angular/core';
import { TextSuggestionRepository } from '../repositories/text-suggestion.repository';
import { TextSuggestion } from '../types/text-suggestion';

/** The Textbausteine of a usage, in the order SoftTOP keeps them. Nothing maintained or a failed load gives an
 *  empty list, so the dialog simply offers no chips; a failure is not remembered and the next call asks again. */
@Injectable()
export class TextSuggestionService {
  private readonly repository = inject(TextSuggestionRepository);
  private readonly cache = new Map<string, readonly TextSuggestion[]>();

  async load(usage: string): Promise<readonly TextSuggestion[]> {
    const cached = this.cache.get(usage);
    if (cached) return cached;
    try {
      const list = await this.repository.list(usage);
      const suggestions = Array.isArray(list) ? list : [];
      this.cache.set(usage, suggestions);
      return suggestions;
    } catch {
      return [];
    }
  }
}
